import { render, staticRenderFns } from "./ModalFile.vue?vue&type=template&id=2db0bc02&"
import script from "./ModalFile.vue?vue&type=script&lang=js&"
export * from "./ModalFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports